webpackJsonp([27],{

/***/ 1346:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export removeDefaultParams */
/* unused harmony export trimParams */
/* harmony export (immutable) */ __webpack_exports__["c"] = removeEmptyParams;
/* harmony export (immutable) */ __webpack_exports__["d"] = setParams;
/* unused harmony export setDefaultParams */
/* unused harmony export conveDataType */
/* harmony export (immutable) */ __webpack_exports__["a"] = conveSomeDataType;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);


/*
 * 表格页面的通用方法
 * @Author: anker.wang
 * @Date: 2018-01-08 11:25:59
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-06-27 12:12:26
 * @Description 路由参数自动同步到搜索参数;在路由更新时获得表格数据;使用分页和搜索事件自动变更路由
 */



/* harmony default export */ __webpack_exports__["b"] = ({
  data: function data() {
    return {
      // 搜索表单字段
      search: {},
      // 搜索字段申明
      searchFieldType: {},
      // 表格数据
      table: [],
      // 分页参数
      pagination: {
        current_page: 1,
        per_page: 50,
        total: 0
      },
      refSearchForm: 'searchForm',
      lastSeachParams: {},
      isLoadTableInBeforeRouteEnter: true,
      isLoadTableInBeforeRouteUpdate: true
    };
  },

  // 路由进入时
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    // 在导航转入新的路由前
    next(function (vm) {
      if (vm.isLoadTableInBeforeRouteEnter) {
        // 处理路由参数
        var queryParams = vm.getRouterQueryParams(to.query);
        // 设置搜索参数
        vm.setSearchParams(queryParams);
        // 加载表格数据
        vm.loadTableData(queryParams);
      }
    });
  },

  // 路由更新时
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    if (this.isLoadTableInBeforeRouteUpdate) {
      // 处理路由参数
      var queryParams = this.getRouterQueryParams(to.query);
      // 加载表格数据
      this.loadTableData(queryParams);
    }
    // 继续加载路由
    next();
  },

  methods: {
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData: function getTableData(params) {},

    /**
     * 设置表格数据
     * @param {*} params
     */
    setTableData: function setTableData(_ref) {
      var data = _ref.data;

      this.$set(this, 'table', data.data);
      this.setPagination(data);
    },

    /**
     * 获得搜索参数
     */
    getSearchParams: function getSearchParams() {
      return this.search;
    },

    /**
     * 设置搜索参数
     */
    setSearchParams: function setSearchParams(params) {
      setParams(this.search, params);
    },

    /**
     * 获得搜索参数的类型声明
     * @description 从路由上同步参数时会造成获得全部都是字符串
     */
    getSearchFieldType: function getSearchFieldType() {
      return this.searchFieldType;
    },

    /**
     * 获取分页数据
     */
    getPagination: function getPagination() {
      return {
        current_page: this.pagination.current_page,
        per_page: this.pagination.per_page
      };
    },

    /**
     * 设置分页数据
     * @pagination {current_page, per_page, total}
     */
    setPagination: function setPagination(pagination) {
      // 转换数据类型
      pagination = conveSomeDataType(pagination, this.pagination);
      // 设置参数
      setParams(this.pagination, pagination);
    },

    /**
     * 处理分页大小时的变化
     * @param {*} val
     */
    handleSizePageChange: function handleSizePageChange(val) {
      this.setPagination({ per_page: val });
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), this.getPagination()));
    },

    /**
     * 处理页码变化
     * @param {*} val
     */
    handleCurrentPageChange: function handleCurrentPageChange(val) {
      this.setPagination({ current_page: val });
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), this.getPagination()));
    },

    /**
     * 获得路由参数
     * 必须 search 中存在的字段，通过申明的类型转换
     * @param {*} query
     */
    getRouterQueryParams: function getRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.$route.query;

      // 删除标识路由更新的空名字段
      if (query.hasOwnProperty('')) {
        delete query[''];
      }
      // 获得参数默认值

      var _$options$data$call = this.$options.data.call(this),
          pagination = _$options$data$call.pagination,
          search = _$options$data$call.search;

      return conveSomeDataType(query, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, search, pagination), this.getSearchFieldType());
    },

    /**
     * 设置路由参数
     * @description 设置路由参数
     */
    setRouterQueryParams: function setRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _$options$data$call2 = this.$options.data.call(this),
          pagination = _$options$data$call2.pagination,
          search = _$options$data$call2.search;

      this.$router.replace({
        query: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, removeEmptyParams(trimParams(removeDefaultParams(query, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, search, pagination)))), {
          // 用于相同的搜索参数时也触发路由更新
          '': __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('HHmmssSS')
        })
      });
    },

    /**
     * 加载表格数据
     * @param {*} params
     */
    loadTableData: function loadTableData(params) {
      // 移除空的参数
      params = removeEmptyParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getSearchParams(), params));
      // 设置默认分页大小值

      var _$options$data$call3 = this.$options.data.call(this),
          pagination = _$options$data$call3.pagination;

      params = setDefaultParams(params, {
        current_page: pagination.current_page,
        per_page: pagination.per_page
      });
      // 保存本次请求参数
      this.lastSeachParams = params;
      // 获得表格数据
      this.getTableData(params).then(this.setTableData);
    },

    /**
     * 刷新当前页的表格数据
     */
    onRefresh: function onRefresh() {
      // 根据上次请求数据再次获取
      return this.getTableData(this.lastSeachParams).then(this.setTableData);
    },

    /**
     * 搜索列表方法
     * @param {*} params
     */
    onSearch: function onSearch(params) {
      var _this = this;

      var search = function search() {
        _this.setPagination({ current_page: 1 });
        _this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this.getPagination(), _this.getSearchParams(), params));
      };
      // 验证填写参数
      var searchForm = this.$refs[this.refSearchForm];
      if (searchForm) {
        searchForm.validate(function (valid) {
          if (valid) {
            search();
          } else {
            _this.$message.error('搜索内容填写不正确！');
          }
        });
      } else {
        search();
      }
    },

    /**
     * 重置表单方法
     */
    resetSearch: function resetSearch() {
      this.$refs[this.refSearchForm].resetFields();
    }
  }

  /**
   * 移除参数中的默认参数
   * @param params
   * @param defaultParams
   * @returns {*}
   */
});function removeDefaultParams(params, defaultParams) {
  for (var key in defaultParams) {
    if (defaultParams.hasOwnProperty(key) && params.hasOwnProperty(key)) {
      if (_.isEqual(defaultParams[key], params[key])) {
        delete params[key];
      }
    }
  }
  return params;
}

/**
 * 移除参数中字符串的前后空格
 * @param params
 * @param defaultParams
 * @returns {*}
 */
function trimParams(params) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && typeof params[key] === 'string') {
      params[key] = params[key].trim();
    }
  }
  return params;
}

/**
 * 删除空的参数
 * @param params
 * @returns {*}
 */
function removeEmptyParams(params) {
  for (var key in params) {
    if (params.hasOwnProperty(key)) {
      // 为数组时必须长度大于0
      if (params[key] instanceof Array && params[key].length === 0) {
        delete params[key];
      }
      // 空字符串或者null时删除字段
      if (params[key] === '' || params[key] === null) {
        delete params[key];
      }
    }
  }
  return params;
}

/**
 * 设置数据
 * @param params
 * @param newParams
 * @returns {*}
 */
function setParams(params, newParams) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && newParams.hasOwnProperty(key)) {
      params[key] = newParams[key];
    }
  }
  return params;
}

/**
 * 设置默认参数
 * @param params
 * @param defaultParams
 * @returns {*}
 */
function setDefaultParams(params, defaultParams) {
  for (var key in defaultParams) {
    if (defaultParams.hasOwnProperty(key) && !params.hasOwnProperty(key)) {
      params[key] = defaultParams[key];
    }
  }
  return params;
}

/**
 * 数据类型转换
 * @param value
 * @param type
 */
function conveDataType(value, type) {
  // 类型相同不用转换
  if (value.constructor !== type) {
    // 实际类型为对象时进入内部
    if (type.constructor === Object && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(type).length > 0) {
      for (var key in value) {
        if (value.hasOwnProperty(key)) {
          // 声明为对象时逐个转换
          value[key] = conveDataType(value[key], type[key]);
        }
      }
    } else {
      value = type(value);
    }
  }
  return value;
}

/**
 * 转换一些数据类型
 * @param params
 * @param defaultParams
 * @param types
 * @returns {*}
 * @description
 * types = {
 *   count: Number,
 *   object: {
 *     id: Number,
 *     date: Date
 *   },
 *   array: {
 *     0: Number,
 *     1: Boolean
 *   },
 * }
 */
function conveSomeDataType(params, defaultParams, types) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && params[key] !== null && params[key] !== undefined && defaultParams.hasOwnProperty(key)) {
      // 存在数据声明
      if (types && types.hasOwnProperty(key)) {
        params[key] = conveDataType(params[key], types[key]);
      } else if (defaultParams[key] !== null && defaultParams[key] !== undefined) {
        // 不存在获取默认参数的数据原类型
        var paramType = defaultParams[key].constructor;
        // 只对非对象数组的参数进行转换
        if (paramType !== Object) {
          params[key] = conveDataType(params[key], paramType);
        }
      }
    }
  }
  return params;
}

/***/ }),

/***/ 1347:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*
 * ElementUI 日期选择组件的参数
 * @Author: anker.wang
 * @Date: 2018-01-08 11:27:07
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-01-08 11:28:27
 */

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      dateTimePickerOptions: {
        shortcuts: [{
          text: '一周后',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }, {
          text: '三天后',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 3);
            picker.$emit('pick', date);
          }
        }, {
          text: '明天',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '今天',
          onClick: function onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: '昨天',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '三天前',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 3);
            picker.$emit('pick', date);
          }
        }, {
          text: '一周前',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }]
      },
      dateTimePickerRangeOptions: {
        shortcuts: [{
          text: '最近1周',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近1个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近3个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近6个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近1年',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近2年',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 730);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近3年',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 1095);
            picker.$emit('pick', [start, end]);
          }
        }]
      }
    };
  }
});

/***/ }),

/***/ 1364:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//download.js v4.2, by dandavis; 2008-2016. [MIT] see http://danml.com/download.html for tests/usage
// v1 landed a FF+Chrome compat way of downloading strings to local un-named files, upgraded to use a hidden frame and optional mime
// v2 added named files via a[download], msSaveBlob, IE (10+) support, and window.URL support for larger+faster saves than dataURLs
// v3 added dataURL and Blob Input, bind-toggle arity, and legacy dataURL fallback was improved with force-download mime and base64 support. 3.1 improved safari handling.
// v4 adds AMD/UMD, commonJS, and plain browser support
// v4.1 adds url download capability via solo URL argument (same domain/CORS only)
// v4.2 adds semantic variable names, long (over 2MB) dataURL support, and hidden by default temp anchors
// https://github.com/rndme/download


function download(data, strFileName, strMimeType, headers, finishCb) {

  var self = window,
      // this script is only for browsers anyway...
  defaultMime = "application/octet-stream",
      // this default mime also triggers iframe downloads
  mimeType = strMimeType || defaultMime,
      payload = data,
      url = !strFileName && !strMimeType && payload,
      anchor = document.createElement("a"),
      toString = function toString(a) {
    return String(a);
  },
      myBlob = self.Blob || self.MozBlob || self.WebKitBlob || toString,
      fileName = strFileName || "download",
      blob,
      reader;
  myBlob = myBlob.call ? myBlob.bind(self) : Blob;

  if (String(this) === "true") {
    //reverse arguments, allowing download.bind(true, "text/xml", "export.xml") to act as a callback
    payload = [payload, mimeType];
    mimeType = payload[0];
    payload = payload[1];
  }

  if (url && url.length < 2048) {
    // if no filename and no mime, assume a url was passed as the only argument
    fileName = url.split("/").pop().split("?")[0];
    anchor.href = url; // assign href prop to temp anchor
    // if(anchor.href.indexOf(url) !== -1){ // if the browser determines that it's a potentially valid url path:
    var ajax = new XMLHttpRequest();
    ajax.open("GET", url, true);
    ajax.responseType = 'blob';
    for (var _i in headers) {
      if (headers.hasOwnProperty(_i)) {
        ajax.setRequestHeader(_i, headers[_i]);
      }
      // }
      ajax.onload = function (e) {
        download(e.target.response, fileName, defaultMime, headers, finishCb);
      };
      setTimeout(function () {
        ajax.send();
      }, 0); // allows setting custom ajax headers using the return:
      return ajax;
    } // end if valid url?
  } // end if url?


  //go ahead and download dataURLs right away
  if (/^data:([\w+-]+\/[\w+.-]+)?[,;]/.test(payload)) {

    if (payload.length > 1024 * 1024 * 1.999 && myBlob !== toString) {
      payload = dataUrlToBlob(payload);
      mimeType = payload.type || defaultMime;
    } else {
      return navigator.msSaveBlob ? // IE10 can't do a[download], only Blobs:
      navigator.msSaveBlob(dataUrlToBlob(payload), fileName) : saver(payload); // everyone else can save dataURLs un-processed
    }
  } else {
    //not data url, is it a string with special needs?
    if (/([\x80-\xff])/.test(payload)) {
      var i = 0,
          tempUiArr = new Uint8Array(payload.length),
          mx = tempUiArr.length;
      for (i; i < mx; ++i) {
        tempUiArr[i] = payload.charCodeAt(i);
      }payload = new myBlob([tempUiArr], { type: mimeType });
    }
  }
  blob = payload instanceof myBlob ? payload : new myBlob([payload], { type: mimeType });

  function dataUrlToBlob(strUrl) {
    var parts = strUrl.split(/[:;,]/),
        type = parts[1],
        decoder = parts[2] == "base64" ? atob : decodeURIComponent,
        binData = decoder(parts.pop()),
        mx = binData.length,
        i = 0,
        uiArr = new Uint8Array(mx);

    for (i; i < mx; ++i) {
      uiArr[i] = binData.charCodeAt(i);
    }return new myBlob([uiArr], { type: type });
  }

  function saver(url, winMode) {

    if ('download' in anchor) {
      //html5 A[download]
      anchor.href = url;
      anchor.setAttribute("download", fileName);
      anchor.className = "download-js-link";
      anchor.innerHTML = "downloading...";
      anchor.style.display = "none";
      document.body.appendChild(anchor);
      setTimeout(function () {
        anchor.click();
        document.body.removeChild(anchor);
        if (winMode === true) {
          setTimeout(function () {
            self.URL.revokeObjectURL(anchor.href);
          }, 250);
        }
        if (finishCb) {
          finishCb();
        }
      }, 66);
      return true;
    }

    // handle non-a[download] safari as best we can:
    if (/(Version)\/(\d+)\.(\d+)(?:\.(\d+))?.*Safari\//.test(navigator.userAgent)) {
      if (/^data:/.test(url)) url = "data:" + url.replace(/^data:([\w\/\-\+]+)/, defaultMime);
      if (!window.open(url)) {
        // popup blocked, offer direct download:
        if (confirm("Displaying New Document\n\nUse Save As... to download, then click back to return to this page.")) {
          location.href = url;
        }
      }
      return true;
    }

    //do iframe dataURL download (old ch+FF):
    var f = document.createElement("iframe");
    document.body.appendChild(f);

    if (!winMode && /^data:/.test(url)) {
      // force a mime that will download:
      url = "data:" + url.replace(/^data:([\w\/\-\+]+)/, defaultMime);
    }
    f.src = url;
    setTimeout(function () {
      document.body.removeChild(f);
    }, 333);
  } //end saver


  if (navigator.msSaveBlob) {
    // IE10+ : (has Blob, but not a[download] or URL)
    return navigator.msSaveBlob(blob, fileName);
  }

  if (self.URL) {
    // simple fast and modern way using Blob and URL:
    saver(self.URL.createObjectURL(blob), true);
  } else {
    // handle non-Blob()+non-URL browsers:
    if (typeof blob === "string" || blob.constructor === toString) {
      try {
        return saver("data:" + mimeType + ";base64," + self.btoa(blob));
      } catch (y) {
        return saver("data:" + mimeType + "," + encodeURIComponent(blob));
      }
    }

    // Blob but not URL support:
    reader = new FileReader();
    reader.onload = function (e) {
      saver(this.result);
    };
    reader.readAsDataURL(blob);
  }
  return true;
}; /* end download() */

/* harmony default export */ __webpack_exports__["a"] = (download);

/***/ }),

/***/ 1455:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

/*
 * ElementUI 下拉远程搜索
 * @Author: anker.wang
 * @Date: 2018-02-08 13:26:37
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-02-08 13:27:08
 */

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      selectLoading: false
    };
  },

  methods: {
    selectRemoteMethod: function selectRemoteMethod(query, request, callback, params) {
      var _this = this;

      if (query !== '') {
        this.selectLoading = true;
        setTimeout(function () {
          request(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ keyword: query }, params)).then(function (response) {
            callback(response.data);
          }).finally(function () {
            _this.selectLoading = false;
          });
        }, 200);
      } else {
        this.rawCustomerItems = [];
      }
    }
  }
});

/***/ }),

/***/ 166:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InvoiceApplyNewTable_vue__ = __webpack_require__(2733);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0bbb69e0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InvoiceApplyNewTable_vue__ = __webpack_require__(4279);
function injectStyle (ssrContext) {
  __webpack_require__(4273)
  __webpack_require__(4275)
  this["$style"] = __webpack_require__(4277)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0bbb69e0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InvoiceApplyNewTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0bbb69e0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InvoiceApplyNewTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1932:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_mixins_table__ = __webpack_require__(1346);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__core_mixins_table__["b" /* default */]],
  props: {
    scope: Object
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Vuex.mapState({
    user: function user(state) {
      return state.login.user;
    }
  })),
  methods: {
    approveInvoice: function approveInvoice(id) {
      this.$emit('approveInvoice', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.params, { id: id }));
    },
    confirmInvoice: function confirmInvoice(id) {
      this.$emit('confirmInvoice', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.params, { id: id }));
    },
    returnInvoice: function returnInvoice(id) {
      this.$emit('returnInvoice', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.params, { id: id }));
    },
    abandonInvoice: function abandonInvoice(id) {
      this.$emit('abandonInvoice', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.params, { id: id }));
    },
    isShowReturnBtn: function isShowReturnBtn(item) {
      // 已开票，已签收状态，且发起人 显示退票按钮
      return [6, 7].includes(item.status * 1) && item.initiator * 1 === this.user.id * 1;
    }
  }
});

/***/ }),

/***/ 1933:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  props: {
    visible: Boolean,
    isPreReceivedPage: Boolean,
    title: String,
    amountStatistics: Array
  },
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Vuex.mapState({
    options: function options(state) {
      return state.invoiceApply.options;
    }
  })),
  watch: {},
  created: function created() {},
  mounted: function mounted() {},

  methods: {
    closeDialog: function closeDialog() {
      this.$emit('closeDialog');
    }
  }
});

/***/ }),

/***/ 2165:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OperationButtons_vue__ = __webpack_require__(1932);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ede2fd50_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OperationButtons_vue__ = __webpack_require__(2166);
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OperationButtons_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ede2fd50_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OperationButtons_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 2166:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button-gutter',[((_vm.scope.row.status === 3 || _vm.scope.row.status === 1) && parseInt(_vm.user.id) === _vm.scope.row.initiator)?_c('router-link',{attrs:{"to":'/invoice-apply/update/'+_vm.scope.row.id}},[_c('el-button',{attrs:{"type":"primary","size":"mini"}},[_vm._v("修改\n      ")])],1):_vm._e(),_vm._v(" "),([1, 3].includes(parseInt(_vm.scope.row.status)) && parseInt(_vm.user.id) === parseInt(_vm.scope.row.initiator))?_c('el-button',{attrs:{"type":"danger","size":"mini"},on:{"click":function($event){return _vm.abandonInvoice(_vm.scope.row.id)}}},[_vm._v("放弃\n      ")]):_vm._e(),_vm._v(" "),(_vm.scope.row.status === 1 && parseInt(_vm.user.id) === _vm.scope.row.bu_approver)?_c('el-button',{attrs:{"type":"warning","size":"mini"},on:{"click":function($event){return _vm.approveInvoice(_vm.scope.row.id)}}},[_vm._v("BO审批\n      ")]):_vm._e(),_vm._v(" "),(_vm.scope.row.status === 6 && parseInt(_vm.user.id) === _vm.scope.row.initiator)?_c('el-button',{attrs:{"type":"success","size":"mini"},on:{"click":function($event){return _vm.confirmInvoice(_vm.scope.row.id)}}},[_vm._v("客户签收\n      ")]):_vm._e(),_vm._v(" "),(_vm.isShowReturnBtn(_vm.scope.row))?_c('el-button',{attrs:{"type":"danger","size":"mini"},on:{"click":function($event){return _vm.returnInvoice(_vm.scope.row.id)}}},[_vm._v("申请退票\n      ")]):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 2167:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SumTaxedAmountDialog_vue__ = __webpack_require__(1933);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1db3a76f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SumTaxedAmountDialog_vue__ = __webpack_require__(2174);
function injectStyle (ssrContext) {
  __webpack_require__(2168)
  __webpack_require__(2170)
  this["$style"] = __webpack_require__(2172)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1db3a76f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SumTaxedAmountDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1db3a76f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SumTaxedAmountDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 2168:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2169);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("7875c078", content, true, {});

/***/ }),

/***/ 2169:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"SumTaxedAmountDialog.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 2170:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2171);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("22715f10", content, true, {});

/***/ }),

/***/ 2171:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"SumTaxedAmountDialog.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 2172:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2173);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("09a617e4", content, true, {});

/***/ }),

/***/ 2173:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"SumTaxedAmountDialog.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 2174:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":_vm.title,"visible":_vm.visible,"before-close":_vm.closeDialog,"width":"50%"}},[(_vm.isPreReceivedPage)?_c('span',[_vm._v("提示: 仅统计已签收状态的预收款发票信息"),_c('br'),_c('br')]):_vm._e(),_vm._v(" "),_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.amountStatistics,"stripe":"","highlight-current-row":"","border":""}},[(!_vm.isPreReceivedPage)?[_c('el-table-column',{key:"status",attrs:{"prop":"status","label":"状态","min-width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._l((_vm.options.status),function(item){return (scope.row.status * 1 === item.value)?_c('span',{style:({color: item.color})},[_vm._v(_vm._s(item.label))]):_vm._e()}),_vm._v(" "),(scope.row.status * 1 === -1)?_c('span',[_vm._v("总计")]):_vm._e()]}}],null,false,1404494136)}),_vm._v(" "),_c('el-table-column',{key:"length",attrs:{"prop":"length","label":"开票笔数","width":"190"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n          "+_vm._s(scope.row.length)+"\n        ")]}}],null,false,3551999969)}),_vm._v(" "),_c('el-table-column',{key:"untaxed_amount",attrs:{"prop":"untaxed_amount","label":"未税金额汇总","width":"190"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n          ￥"+_vm._s(_vm._f("seperateThousandsToFixed")(scope.row.untaxed_amount,2))+"\n        ")]}}],null,false,56680922)}),_vm._v(" "),_c('el-table-column',{key:"total",attrs:{"prop":"total","label":"含税金额汇总","width":"190"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n          ￥"+_vm._s(_vm._f("seperateThousandsToFixed")(scope.row.total,2))+"\n        ")]}}],null,false,1745734140)})]:_vm._e(),_vm._v(" "),(_vm.isPreReceivedPage)?[_c('el-table-column',{key:"deduction_status",attrs:{"prop":"deduction_status","label":"抵扣状态","min-width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._l((_vm.options.deduction_status),function(item){return (scope.row.deduction_status * 1 === item.value)?_c('span',{style:({color: item.color})},[_vm._v(_vm._s(item.label))]):_vm._e()}),_vm._v(" "),(scope.row.deduction_status * 1 === -1)?_c('span',[_vm._v("总计")]):_vm._e()]}}],null,false,696642760)}),_vm._v(" "),_c('el-table-column',{key:"deduction_length",attrs:{"prop":"length","label":"开票笔数","width":"90"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n          "+_vm._s(scope.row.length)+"\n        ")]}}],null,false,3551999969)}),_vm._v(" "),_c('el-table-column',{key:"available_deduct_amount",attrs:{"prop":"available_deduct_amount","label":"可用抵扣金额汇总","width":"190"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n          ￥"+_vm._s(_vm._f("seperateThousandsToFixed")(scope.row.available_deduct_amount,2))+"\n        ")]}}],null,false,3060128780)}),_vm._v(" "),_c('el-table-column',{key:"freeze_deduct_amount",attrs:{"prop":"freeze_deduct_amount","label":"冻结抵扣金额汇总","width":"190"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n          ￥"+_vm._s(_vm._f("seperateThousandsToFixed")(scope.row.freeze_deduct_amount,2))+"\n        ")]}}],null,false,3426210526)}),_vm._v(" "),_c('el-table-column',{key:"deducted_amount",attrs:{"prop":"deducted_amount","label":"已抵扣金额汇总","width":"190"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n          ￥"+_vm._s(_vm._f("seperateThousandsToFixed")(scope.row.deducted_amount,2))+"\n        ")]}}],null,false,2891171947)})]:_vm._e()],2),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":_vm.closeDialog}},[_vm._v("确认")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 2733:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vendor_download__ = __webpack_require__(1364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_invoice_apply_components_OperationButtons__ = __webpack_require__(2165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_invoice_apply_components_SumTaxedAmountDialog__ = __webpack_require__(2167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__core_mixins_dateTimePicker__ = __webpack_require__(1347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__core_mixins_selectRemote__ = __webpack_require__(1455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__core_mixins_table__ = __webpack_require__(1346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_auth__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__core_components_RemoteSelect__ = __webpack_require__(248);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_9__core_mixins_table__["b" /* default */], __WEBPACK_IMPORTED_MODULE_7__core_mixins_dateTimePicker__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__core_mixins_selectRemote__["a" /* default */]],
  components: {
    RemoteSelect: __WEBPACK_IMPORTED_MODULE_11__core_components_RemoteSelect__["a" /* default */],
    OperationButtons: __WEBPACK_IMPORTED_MODULE_5__views_invoice_apply_components_OperationButtons__["a" /* default */],
    SumTaxedAmountDialog: __WEBPACK_IMPORTED_MODULE_6__views_invoice_apply_components_SumTaxedAmountDialog__["a" /* default */]
  },
  data: function data() {
    return {
      search: {
        id: null,
        status: [],
        customerid: null,
        bu_approver: null,
        initiator: null,
        created_at: [],
        invoice_time: [],
        sort_by_updated_at: null,
        sort_by_id: null,
        total_amount_min: null,
        total_amount_max: null,
        project_number: null,
        issued_type: null,
        deduction_status: null,
        received_payment_status: null,
        subject: null,
        collection_date: []
      },
      searchFieldType: {
        customerid: String,
        bu_approver: Number,
        initiator: Number,
        total_amount_min: Number,
        total_amount_max: Number,
        project_number: String,
        received_payment_status: Number,
        subject: Number
      },
      exportErrVisible: false,
      sumVisible: false,
      title: null,
      amountStatistics: [],
      paymentCompanies: {},
      mulSelection: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Vuex.mapState({
    options: function options(state) {
      return state.invoiceApply.options;
    },
    user: function user(state) {
      return state.login.user;
    },
    exportHeader: function exportHeader(state) {
      return state.invoiceApply.receipt_export_headers;
    },
    exportPreHeader: function exportPreHeader(state) {
      return state.invoiceApply.pre_receipt_export_headers;
    },
    receivedPaymentStatus: function receivedPaymentStatus(state) {
      return state.invoiceApply.options.received_payment_status;
    }
  })),
  created: function created() {
    this.setDefaultStatus();
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      vm.getFinCenterConfigs();
    });
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    // 离开时，清除当前页面设置的查询参数，避免在其他的提现页面保留这些查询参数
    if (this.$route.meta.is_pre_received) {
      this.search.issued_type = null;
    }
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(this.$data, this.$options.data.call(this));
    next();
  },

  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Vuex.mapActions(['getCustomerTable', 'getPlatformUsersIndex', 'getPlatformUsersDetail']), request.map(['getFinCenterOurCompaniesTable', 'getFinCenterOurCompaniesDetail']), {
    setDefaultStatus: function setDefaultStatus() {
      this.search.status = this.$route.query.status || null;
    },
    isFromTodoAudit: function isFromTodoAudit() {
      return this.$route.meta.type === 'approval';
    },

    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData: function getTableData(params) {
      this.search.is_from_todo_audit = this.isFromTodoAudit();
      params.is_from_todo_audit = this.isFromTodoAudit();
      return request.page('getInvoiceApplyTable', params);
    },
    sortChange: function sortChange(column, prop, order) {
      this.search.sort_by_id = this.search.sort_by_updated_at = null;
      var sortBy = 'asc';
      if (column.order === 'descending') {
        sortBy = 'desc';
      }
      if (column.prop === 'id') {
        this.search.sort_by_id = sortBy;
      } else if (column.prop === 'updated_at') {
        this.search.sort_by_updated_at = sortBy;
      }
      this.onSearch();
    },
    resetSearch: function resetSearch() {
      this.$refs[this.refSearchForm].resetFields();
      if (this.$route.meta.is_pre_received) {
        this.search.issued_type = '2';
      }
    },
    getExportData: function getExportData(params) {
      if (this.$route.meta.is_pre_received) {
        // 预收款发票数据导出,未指定状态时,锁定导出已签收状态的发票
        if (!params.status) {
          params.status = [7];
        }
        params.has_passed_deduction = 1;
        return request.page('getExportPreReceivedApproveTable', params);
      }
      return request.page('getExportApproveTable', params);
    },
    onExportSearchFix: function onExportSearchFix() {
      var _this = this;

      var params = filter.copyJson(Object(__WEBPACK_IMPORTED_MODULE_9__core_mixins_table__["c" /* removeEmptyParams */])(this.search));
      params.per_page = 1;
      params.is_from_todo_audit = this.isFromTodoAudit();
      this.getExportData(params).then(function (_ref) {
        var data = _ref.data;

        if (data.data.length < 1 && _this.$route.meta.is_pre_received) {
          _this.exportErrVisible = true;
        } else {
          _this.onExportSearch();
        }
      });
    },
    onExportSearch: function onExportSearch() {
      var _this2 = this;

      var fileHeader = this.$route.meta.is_pre_received ? this.exportPreHeader : this.exportHeader;
      this.$export(this.$route.meta.title, {
        fileHeader: fileHeader,
        total: this.pagination.total,
        request: this.getExportData,
        requestParams: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, this.search, { is_from_todo_audit: this.isFromTodoAudit() }),
        getResponseData: function getResponseData(data) {
          data.data = _this2.handleExportData(data.data);
          return data;
        }
      });
    },
    handleExportData: function handleExportData(data) {
      var _this3 = this;

      data.forEach(function (row) {
        row.tax_rate = row.tax_rate + '%';
        row.buyer_company_name = row.receipt_info_json.company_name || ''; // 购买方公司名称
        row.buyer_tax_number = row.receipt_info_json.tax_number || ''; // 购买方纳税人识别号
        row.quantity = row.quantity > 0 ? row.quantity : ''; // 数量大于0时显示数字
        _this3.options.tax_type.forEach(function (status) {
          if (status.value * 1 === row.invoice_tax_type * 1) {
            row.invoice_tax_type_cn = status.label;
          }
        });
        _this3.options.status.forEach(function (status) {
          if (status.value * 1 === row.status * 1) {
            row.status = status.label;
          }
        });
        _this3.options.issued_type.forEach(function (issuedType) {
          if (issuedType.value * 1 === row.issued_type * 1) {
            row.issued_type = issuedType.label;
          }
        });
        if (row.subject) {
          row.subject = _this3.paymentCompanies[row.subject];
        }
        _this3.options.type.forEach(function (type) {
          if (type.value * 1 === row.type * 1) {
            row.type = type.label;
          }
        });
        if (row.deduction_status) {
          _this3.options.deduction_status.forEach(function (deductType) {
            if (deductType.value * 1 === row.deduction_status * 1) {
              row.deduction_status = deductType.label;
            }
          });
        }
      });
      return data;
    },
    onExportRows: function onExportRows(id) {
      this.$export(this.$route.meta.title, {
        type: 'array',
        request: function (_request) {
          function request(_x) {
            return _request.apply(this, arguments);
          }

          request.toString = function () {
            return _request.toString();
          };

          return request;
        }(function (params) {
          return request('exportInvoiceApplyData', params);
        }),
        requestParams: { id: id },
        getResponseData: function getResponseData(data) {
          // 导出大于一页时去掉标题行
          data.current_page > 1 && data.data.splice(0, 1);
          return data;
        }
      });
    },
    customerRemoteMethod: function customerRemoteMethod(query) {
      return request.common('getCustomerTable', { keyword: query.name, type: [10, 70] });
    },
    getCustomerInfoRemote: function getCustomerInfoRemote() {
      return request.common('getCustomerDetail', { id: this.search.customerid });
    },
    customerLabel: function customerLabel(item) {
      return item.name + '/' + item.number;
    },
    openDetail: function openDetail(id) {
      this.$router.push('/invoice-apply/detail/' + id + '?type=detail&from=apply');
    },
    approve: function approve(id) {
      // 开票申请 - BO审批'
      this.$router.push('/invoice-apply/review/bu-review/' + id.id);
    },
    approveDeduct: function approveDeduct(id) {
      // 开票申请 - 抵扣-BO审批
      this.$router.push('/invoice-apply/review/bu-deduct/' + id.id);
    },
    abandonDeduct: function abandonDeduct(id) {
      // 开票申请 - 放弃抵扣
      this.$router.push('/invoice-apply/review/waiver-deduct/' + id.id);
    },
    applyDeduct: function applyDeduct(id) {
      // 开票申请 - 抵扣申请
      this.$router.push('/invoice-apply/review/deduct-apply/' + id.id);
    },
    confirm: function confirm(id) {
      // 开票申请 - 客户签收
      this.$router.push('/invoice-apply/review/signed-off/' + id.id);
    },
    returnReceipt: function returnReceipt(id) {
      // 开票申请 - 申请退票
      this.$router.push('/invoice-apply/review/return/' + id.id);
    },
    abandon: function abandon(id) {
      // 开票申请 - 放弃申请
      this.$router.push('/invoice-apply/review/abandon/' + id.id);
    },
    closeExportErrDialog: function closeExportErrDialog() {
      this.exportErrVisible = false;
    },
    openSumTaxedAmountDialog: function openSumTaxedAmountDialog() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var params;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this4.amountStatistics = [];
                params = Object(__WEBPACK_IMPORTED_MODULE_9__core_mixins_table__["c" /* removeEmptyParams */])(filter.copyJson(_this4.search));

                params.is_from_todo_audit = _this4.isFromTodoAudit();

                if (!_this4.$route.meta.is_pre_received) {
                  _context.next = 10;
                  break;
                }

                params.issued_type = '2';
                params.status = ['7'];
                _context.next = 8;
                return request.common('getPrepareInvoiceAmountTotal', params).then(function (data) {
                  var totalLength = 0;
                  var totalAvailableAmount = 0;
                  var totalFreezeAmount = 0;
                  var totalDeductedAmount = 0;
                  for (var i in data.data) {
                    if (data.data.hasOwnProperty(i)) {
                      totalLength += data.data[i].length;
                      totalAvailableAmount += data.data[i].available_deduct_amount;
                      totalFreezeAmount += data.data[i].freeze_deduct_amount;
                      totalDeductedAmount += data.data[i].deducted_amount;
                      _this4.amountStatistics.push(data.data[i]);
                    }
                  }
                  if (totalLength) {
                    _this4.amountStatistics.push({
                      'deduction_status': -1, // -1 为 总计 列，需单独处理显示文字
                      'length': totalLength,
                      'available_deduct_amount': totalAvailableAmount,
                      'freeze_deduct_amount': totalFreezeAmount,
                      'deducted_amount': totalDeductedAmount
                    });
                  }
                  _this4.title = '预收款开票统计';
                  _this4.sumVisible = true;
                });

              case 8:
                _context.next = 12;
                break;

              case 10:
                _context.next = 12;
                return request.common('getInvoiceAmountTotal', params).then(function (data) {
                  var totalLength = 0;
                  var totalTaxedAmount = 0;
                  var totalUntaxedAmount = 0;
                  for (var i in data.data) {
                    if (data.data.hasOwnProperty(i)) {
                      totalLength += data.data[i].length;
                      totalTaxedAmount += data.data[i].total;
                      totalUntaxedAmount += data.data[i].untaxed_amount;
                      _this4.amountStatistics.push(data.data[i]);
                    }
                  }
                  if (totalLength) {
                    _this4.amountStatistics.push({
                      'status': -1, // -1 为 总计 列，需单独处理显示文字
                      'length': totalLength,
                      'untaxed_amount': totalUntaxedAmount,
                      'total': totalTaxedAmount
                    });
                  }
                  _this4.title = '开票统计';
                  _this4.sumVisible = true;
                });

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this4);
      }))();
    },
    changeDeductionStatus: function changeDeductionStatus() {
      if (this.search.deduction_status * 1 === 1) {
        if (this.search.status.length === 0) {
          this.search.status = ['7'];
        }
      }
    },
    isShowAbandonBtn: function isShowAbandonBtn(item) {
      return item.deduct_detail_status_list.includes(1) && this.user.id * 1 === item.initiator * 1;
    },
    isShowApproveBtn: function isShowApproveBtn(item) {
      // 超管和指定的bu审批人可以看到按钮
      return item.deduct_detail_status_list.includes(1) && (this.user.id * 1 === item.bu_approver * 1 || this.user.usertype * 1 === 1);
    },
    isShowDeductBtn: function isShowDeductBtn(item) {
      return item.issued_type * 1 === 2 && item.status * 1 === 7;
    },
    amountStyle: function amountStyle(row) {
      return row.untaxed_amount * 1 > 0 && [11, 14, 17].includes(row.status * 1) || row.untaxed_amount < 0 ? 'color:red;' : '';
    },
    redirectToApproveTable: function redirectToApproveTable() {
      this.$router.push({ path: '/invoice-apply/approval' });
    },
    isSearchItemDisplay: function isSearchItemDisplay() {
      return this.$route.meta.type !== 'approval';
    },
    showRefundStatus: function showRefundStatus(row) {
      if ([6, 7, 8].includes(row.status)) {
        return (this.receivedPaymentStatus.find(function (item) {
          return item.value === row.received_payment_status;
        }) || {}).label;
      } else {
        return '-';
      }
    },
    batchDownloadPdf: function batchDownloadPdf() {
      request.common('batchDownloadInvoicePdfs', { id: this.mulSelection }).then(function (data) {
        var filename = data.data;
        var api = request.items.downloadPdfFileFromServer({ filename: filename });
        Object(__WEBPACK_IMPORTED_MODULE_4__vendor_download__["a" /* default */])(api, false, false, {
          'SJ-Auth-Token': Object(__WEBPACK_IMPORTED_MODULE_10__utils_auth__["c" /* getToken */])()
        });
      });
    },
    getFinCenterConfigs: function getFinCenterConfigs() {
      var _this5 = this;

      return request.common('getFinCenterConfigs').then(function (_ref2) {
        var data = _ref2.data;

        _this5.paymentCompanies = _this5.expandData(data.payment_apply_our_company_source);
      });
    },
    expandData: function expandData(data) {
      var result = {};
      for (var dataKey in data) {
        var tmp = data[dataKey];
        result[tmp.id] = tmp.name;
      }
      return result;
    },
    createInvoiceApply: function createInvoiceApply() {
      var _this6 = this;

      request.loading('getuserAccountDetailByUserID', { id: this.user.id }).then(function (_ref3) {
        var data = _ref3.data;

        if (data.length) {
          _this6.$router.push('/invoice-apply/create');
        } else {
          throw Error('请联系人事或管理员将您更新至员工账户列表');
        }
      }).catch(function (_) {
        _this6.$alert('请联系人事或管理员将您更新至员工账户列表', '提示', { type: 'warning' }).then(function () {});
      });
    }
  })
});

/***/ }),

/***/ 4273:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4274);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("c13de1f8", content, true, {});

/***/ }),

/***/ 4274:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"InvoiceApplyNewTable.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 4275:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4276);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("8631a738", content, true, {});

/***/ }),

/***/ 4276:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"InvoiceApplyNewTable.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 4277:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4278);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("5af7970c", content, true, {});

/***/ }),

/***/ 4278:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"InvoiceApplyNewTable.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 4279:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{staticStyle:{"width":"80%","float":"left"},attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":"/"}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("客户管理")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1),_vm._v(" "),(!_vm.$route.meta.is_pre_received)?_c('router-link',{staticStyle:{"float":"right"},attrs:{"to":"/invoice-apply/pre-received/table?issued_type=2"}},[_vm._v("\n      预收款开票管理\n    ")]):_vm._e()],1),_vm._v(" "),_c('layout-panel',{attrs:{"collapse":false}},[_c('template',{slot:"header"},[_vm._v("搜索")]),_vm._v(" "),_c('el-form',{ref:"searchForm",attrs:{"model":_vm.search,"label-width":"96px","label-position":"right","size":"medium"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSearch()}}},[_c('div',{staticClass:"re-el-form__flex"},[_c('el-form-item',{key:"id",attrs:{"label":"开票ID","prop":"id"}},[_c('el-input',{attrs:{"clearable":"","placeholder":"请输入开票ID"},model:{value:(_vm.search.id),callback:function ($$v) {_vm.$set(_vm.search, "id", $$v)},expression:"search.id"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"客户名称","prop":"customerid"}},[_c('remote-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","remote":"","clearable":"","id-key":"number","keyword-key":"name","label":_vm.customerLabel,"value-key":"id","placeholder":"请输入客户名称/编号搜索","query-request":_vm.customerRemoteMethod,"find-request":_vm.getCustomerInfoRemote},on:{"change":function($event){_vm.search.projectid=null}},model:{value:(_vm.search.customerid),callback:function ($$v) {_vm.$set(_vm.search, "customerid", $$v)},expression:"search.customerid"}})],1),_vm._v(" "),(_vm.isSearchItemDisplay())?_c('el-form-item',{attrs:{"label":"BO审批","prop":"bu_approver"}},[_c('remote-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","remote":"","clearable":"","id-key":"id","keyword-key":"name","label-key":"name","value-key":"id","placeholder":"请输入管理员名称搜索","query-request":function (_){ return _vm.getPlatformUsersIndex(Object.assign(_, {usertype: [1, 2, 3, 4, 5]})); },"find-request":_vm.getPlatformUsersDetail},model:{value:(_vm.search.bu_approver),callback:function ($$v) {_vm.$set(_vm.search, "bu_approver", $$v)},expression:"search.bu_approver"}})],1):_vm._e(),_vm._v(" "),(_vm.isSearchItemDisplay())?_c('el-form-item',{attrs:{"label":"申请描述","prop":"desc"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"clearable":"","placeholder":"请输入申请描述关键字搜索"},model:{value:(_vm.search.desc),callback:function ($$v) {_vm.$set(_vm.search, "desc", $$v)},expression:"search.desc"}})],1):_vm._e(),_vm._v(" "),(_vm.isSearchItemDisplay())?_c('el-form-item',{attrs:{"label":"开票状态","prop":"status"}},[_c('el-select',{staticClass:"width-max",attrs:{"clearable":"","multiple":"","placeholder":"请选择"},model:{value:(_vm.search.status),callback:function ($$v) {_vm.$set(_vm.search, "status", $$v)},expression:"search.status"}},_vm._l((_vm.options.status),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value + ''}})}),1)],1):_vm._e(),_vm._v(" "),(_vm.isSearchItemDisplay())?_c('el-form-item',{attrs:{"label":"创建时间","prop":"created_at"}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"datetimerange","range-separator":"至","start-placeholder":"开始日期","end-placeholder":"结束日期","align":"right","default-time":['00:00:00', '23:59:59'],"value-format":"yyyy-MM-dd HH:mm:ss"},model:{value:(_vm.search.created_at),callback:function ($$v) {_vm.$set(_vm.search, "created_at", $$v)},expression:"search.created_at"}})],1):_vm._e(),_vm._v(" "),(_vm.isSearchItemDisplay())?_c('el-form-item',{attrs:{"label":"开票日期","prop":"invoice_time"}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"datetimerange","range-separator":"至","start-placeholder":"开始日期","end-placeholder":"结束日期","align":"right","default-time":['00:00:00', '23:59:59'],"value-format":"yyyy-MM-dd HH:mm:ss"},model:{value:(_vm.search.invoice_time),callback:function ($$v) {_vm.$set(_vm.search, "invoice_time", $$v)},expression:"search.invoice_time"}})],1):_vm._e(),_vm._v(" "),(_vm.isSearchItemDisplay())?_c('el-form-item',{attrs:{"label":"开票金额"}},[_c('el-col',{attrs:{"span":11}},[_c('el-form-item',{attrs:{"prop":"total_amount_min"}},[_c('el-input',{attrs:{"clearable":"","placeholder":"请输入含税金额起始值"},model:{value:(_vm.search.total_amount_min),callback:function ($$v) {_vm.$set(_vm.search, "total_amount_min", $$v)},expression:"search.total_amount_min"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":1}},[_c('div',[_vm._v("  至  ")])]),_vm._v(" "),_c('el-col',{attrs:{"span":11,"offset":1}},[_c('el-form-item',{attrs:{"prop":"total_amount_max"}},[_c('el-input',{attrs:{"clearable":"","placeholder":"请输入含税金额结束值"},model:{value:(_vm.search.total_amount_max),callback:function ($$v) {_vm.$set(_vm.search, "total_amount_max", $$v)},expression:"search.total_amount_max"}})],1)],1)],1):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"label":"项目编号","prop":"project_number"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"clearable":"","placeholder":"请输入项目编号搜索"},model:{value:(_vm.search.project_number),callback:function ($$v) {_vm.$set(_vm.search, "project_number", $$v)},expression:"search.project_number"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"开票类别","prop":"issued_type"}},[_c('el-select',{staticClass:"width-max",attrs:{"clearable":"","disabled":_vm.$route.meta.is_pre_received,"placeholder":"请选择"},model:{value:(_vm.search.issued_type),callback:function ($$v) {_vm.$set(_vm.search, "issued_type", $$v)},expression:"search.issued_type"}},_vm._l((_vm.options.issued_type),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value + ''}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"发起人","prop":"initiator"}},[_c('remote-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","remote":"","clearable":"","id-key":"id","keyword-key":"name","label-key":"name","value-key":"id","placeholder":"请输入发起人名称搜索","query-request":function (_){ return _vm.getPlatformUsersIndex(Object.assign(_, {usertype: [1, 2, 3, 4, 5]})); },"find-request":_vm.getPlatformUsersDetail},model:{value:(_vm.search.initiator),callback:function ($$v) {_vm.$set(_vm.search, "initiator", $$v)},expression:"search.initiator"}})],1),_vm._v(" "),(_vm.$route.meta.is_pre_received && _vm.isSearchItemDisplay())?_c('el-form-item',{attrs:{"label":"抵扣状态","prop":"deduction_status"}},[_c('el-select',{staticClass:"width-max",attrs:{"clearable":"","placeholder":"请选择"},on:{"change":_vm.changeDeductionStatus},model:{value:(_vm.search.deduction_status),callback:function ($$v) {_vm.$set(_vm.search, "deduction_status", $$v)},expression:"search.deduction_status"}},_vm._l((_vm.options.deduction_status),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value + ''}})}),1)],1):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"label":"开票主体","prop":"subject"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","id-key":"id","keyword-key":"name","label-key":"name","value-key":"id","placeholder":"仅支持搜索启用中的开票主体公司,可输入名称进行搜索","query-request":function (_){ return _vm.getFinCenterOurCompaniesTable(Object.assign(_, {is_disabled: 0})); },"find-request":_vm.getFinCenterOurCompaniesDetail},model:{value:(_vm.search.subject),callback:function ($$v) {_vm.$set(_vm.search, "subject", $$v)},expression:"search.subject"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"回款状态","prop":"received_payment_status"}},[_c('el-select',{staticClass:"width-max",attrs:{"clearable":""},model:{value:(_vm.search.received_payment_status),callback:function ($$v) {_vm.$set(_vm.search, "received_payment_status", $$v)},expression:"search.received_payment_status"}},_vm._l((_vm.receivedPaymentStatus),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"回款日期","prop":"collection_date"}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"datetimerange","range-separator":"至","start-placeholder":"开始日期","end-placeholder":"结束日期","align":"right","default-time":['00:00:00', '23:59:59'],"value-format":"yyyy-MM-dd HH:mm:ss"},model:{value:(_vm.search.collection_date),callback:function ($$v) {_vm.$set(_vm.search, "collection_date", $$v)},expression:"search.collection_date"}})],1)],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-search","native-type":"submit"}},[_vm._v("搜索\n        ")]),_vm._v(" "),_c('el-button',{on:{"click":function($event){return _vm.resetSearch()}}},[_vm._v("重置")])],1)],1)],2),_vm._v(" "),_c('layout-panel',[_c('template',{slot:"header"},[_vm._v("列表")]),_vm._v(" "),_c('template',{slot:"tools"},[_c('el-button',{attrs:{"type":"primary","size":"small","icon":"el-icon-refresh"},on:{"click":function($event){return _vm.onRefresh()}}})],1),_vm._v(" "),_c('div',{staticClass:"margin b15"},[_c('el-button',{attrs:{"type":"info","size":"small"},on:{"click":_vm.createInvoiceApply}},[_vm._v("添加开票申请\n      ")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":function($event){return _vm.onExportSearchFix()}}},[_vm._v("搜索结果导出\n      ")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.openSumTaxedAmountDialog}},[_vm._v("按搜索结果汇总\n      ")]),_vm._v(" "),(_vm.$route.meta.type !== 'approval')?_c('el-button',{staticStyle:{"float":"right"},attrs:{"type":"success","size":"small"},on:{"click":_vm.redirectToApproveTable}},[_vm._v("查看待审批\n      ")]):_vm._e(),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","disabled":_vm.mulSelection.length < 1,"size":"small"},on:{"click":_vm.batchDownloadPdf}},[_vm._v("批量生成PDF\n      ")])],1),_vm._v(" "),_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.table,"stripe":"","highlight-current-row":"","border":""},on:{"selection-change":function (val) { return this$1.mulSelection = val.map(function (item) { return item.id; }); },"sort-change":_vm.sortChange}},[_c('el-table-column',{attrs:{"type":"selection","width":"40"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"id","label":"ID","sortable":"custom","min-width":"90"}}),_vm._v(" "),_c('el-table-column',{key:"desc",attrs:{"prop":"desc","label":"申请描述","min-width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticStyle:{"color":"#409EFF","cursor":"pointer"},on:{"click":function($event){return _vm.openDetail(scope.row.id)}}},[_vm._v("\n            "+_vm._s(scope.row.desc)+"\n          ")])]}}])}),_vm._v(" "),_c('el-table-column',{key:"customer_number",attrs:{"prop":"customer_number","label":"客户编号","width":"190"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n          "+_vm._s(scope.row.customer_name)+"/"+_vm._s(scope.row.customer_number)+"\n        ")]}}])}),_vm._v(" "),_c('el-table-column',{key:"receipt_info_company_name",attrs:{"prop":"receipt_info_company_name","label":"公司名称","width":"190"}}),_vm._v(" "),(_vm.$route.meta.is_pre_received)?_c('el-table-column',{key:"virtual_project",attrs:{"prop":"virtual_project","label":"项目编号","width":"190"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n          "+_vm._s(scope.row.virtual_project.name)+"/"+_vm._s(scope.row.virtual_project.number)+"\n        ")]}}],null,false,998067323)}):_vm._e(),_vm._v(" "),_c('el-table-column',{key:"issued_type",attrs:{"prop":"issued_type","label":"开票类别","min-width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return _vm._l((_vm.options.issued_type),function(item){return (scope.row.issued_type * 1 === item.value * 1)?_c('span',[_vm._v("\n            "+_vm._s(item.label))]):_vm._e()})}}])}),_vm._v(" "),_c('el-table-column',{key:"status",attrs:{"prop":"status","label":"状态","min-width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return _vm._l((_vm.options.status),function(item){return (scope.row.status === item.value)?_c('span',{style:({color: item.color})},[_vm._v(_vm._s(item.label))]):_vm._e()})}}])}),_vm._v(" "),(_vm.$route.meta.is_pre_received)?_c('el-table-column',{key:"deduction_status",attrs:{"prop":"deduction_status","label":"抵扣状态","min-width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return _vm._l((_vm.options.deduction_status),function(item){return (scope.row.deduction_status * 1 === item.value * 1)?_c('span',[_vm._v("\n              "+_vm._s(scope.row.status * 1 === 7 ? item.label : '-')+"\n            ")]):_vm._e()})}}],null,false,2974319897)}):_vm._e(),_vm._v(" "),(!_vm.$route.meta.is_pre_received)?_c('el-table-column',{key:"untaxed_amount",attrs:{"prop":"untaxed_amount","label":"未税开票金额","min-width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{style:(_vm.amountStyle(scope.row))},[_vm._v("\n            ￥"+_vm._s(_vm._f("seperateThousandsToFixed")(scope.row.untaxed_amount,2))+"\n          ")])]}}],null,false,2666312371)}):_vm._e(),_vm._v(" "),_c('el-table-column',{key:"total",attrs:{"prop":"total","label":"含税开票金额","min-width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{style:(_vm.amountStyle(scope.row))},[_vm._v("\n            ￥"+_vm._s(_vm._f("seperateThousandsToFixed")(scope.row.total,2))+"\n          ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"customer_number","label":"回款状态","width":"190"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n          "+_vm._s(_vm.showRefundStatus(scope.row))+"\n        ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"collection_remains_total","label":"待回款金额","width":"190"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n          "+_vm._s(scope.row.collection_remains_total)+"\n        ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"collection_total","label":"已回款金额","width":"190"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n          "+_vm._s(scope.row.collection_total)+"\n        ")]}}])}),_vm._v(" "),(_vm.$route.meta.is_pre_received)?[_c('el-table-column',{key:"available_deduct_amount",attrs:{"prop":"available_deduct_amount","label":"可用抵扣金额","min-width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.status * 1 === 7)?_c('div',[_vm._v("\n              ￥"+_vm._s(_vm._f("seperateThousandsToFixed")(scope.row.available_deduct_amount,2))+"\n            ")]):_c('div',[_c('span',[_vm._v("-")])])]}}],null,false,345540979)}),_vm._v(" "),_c('el-table-column',{key:"freeze_deduct_amount",attrs:{"prop":"freeze_deduct_amount","label":"冻结抵扣金额","min-width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.status * 1 === 7)?_c('div',[_vm._v("\n              ￥"+_vm._s(_vm._f("seperateThousandsToFixed")(scope.row.freeze_deduct_amount,2))+"\n            ")]):_c('div',[_c('span',[_vm._v("-")])])]}}],null,false,1136861025)}),_vm._v(" "),_c('el-table-column',{key:"deducted_amount",attrs:{"prop":"deducted_amount","label":"已抵扣金额","min-width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.status * 1 === 7)?_c('div',[_vm._v("\n              ￥"+_vm._s(_vm._f("seperateThousandsToFixed")(scope.row.deducted_amount,2))+"\n            ")]):_c('div',[_c('span',[_vm._v("-")])])]}}],null,false,2301785908)})]:_vm._e(),_vm._v(" "),_c('el-table-column',{key:"initiator_name",attrs:{"prop":"initiator_name","label":"发起人","min-width":"120"}}),_vm._v(" "),_c('el-table-column',{key:"bu_name",attrs:{"prop":"bu_name","label":"BO审批","min-width":"120"}}),_vm._v(" "),_c('el-table-column',{key:"updated_at",attrs:{"label":"创建时间 更新时间","min-width":"180","prop":"updated_at","sortable":"custom"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n          "+_vm._s(scope.row.created_at)+" "),_c('br'),_vm._v("\n          "+_vm._s(scope.row.updated_at)+"\n        ")]}}])}),_vm._v(" "),_c('el-table-column',{key:"operation",attrs:{"fixed":"right","label":"操作","width":"200px"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('operation-buttons',{attrs:{"scope":scope},on:{"refresh":_vm.onRefresh,"approveInvoice":_vm.approve,"confirmInvoice":_vm.confirm,"returnInvoice":_vm.returnReceipt,"abandonInvoice":_vm.abandon}}),_vm._v(" "),(_vm.isShowDeductBtn(scope.row))?_c('div',{staticStyle:{"margin-top":"5px"}},[_c('button-gutter',[(scope.row.initiator * 1 === _vm.user.id * 1 && scope.row.available_deduct_amount !== 0)?_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":function($event){return _vm.applyDeduct(scope.row)}}},[_vm._v("抵扣申请\n              ")]):_vm._e(),_vm._v(" "),(_vm.isShowAbandonBtn(scope.row))?_c('el-button',{attrs:{"type":"danger","size":"mini"},on:{"click":function($event){return _vm.abandonDeduct(scope.row)}}},[_vm._v("放弃抵扣\n              ")]):_vm._e(),_vm._v(" "),(_vm.isShowApproveBtn(scope.row))?_c('el-button',{attrs:{"type":"warning","size":"mini"},on:{"click":function($event){return _vm.approveDeduct(scope.row)}}},[_vm._v("抵扣-BO审批\n              ")]):_vm._e()],1)],1):_vm._e()]}}])})],2),_vm._v(" "),_c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"background":"","current-page":_vm.pagination.current_page,"page-sizes":[20, 50, 100, 200],"page-size":_vm.pagination.per_page,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.pagination.total},on:{"size-change":_vm.handleSizePageChange,"current-change":_vm.handleCurrentPageChange}})],1)],2),_vm._v(" "),_c('sum-taxed-amount-dialog',{attrs:{"visible":_vm.sumVisible,"amountStatistics":_vm.amountStatistics,"title":_vm.title,"isPreReceivedPage":_vm.$route.meta.is_pre_received},on:{"closeDialog":function($event){_vm.sumVisible=false}}}),_vm._v(" "),_c('el-dialog',{attrs:{"title":"预收款发票导出错误","visible":_vm.exportErrVisible,"width":"50%"},on:{"close":_vm.closeExportErrDialog}},[_c('span',[_vm._v("搜索结果中无已签收的预收款发票，或者所有已签收的预收款发票中不存在抵扣成功的条目数据")]),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":_vm.closeExportErrDialog}},[_vm._v("确认")])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/invoice-apply-table.7b2d2a556c5ecc317f0b.js